"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleApiError = exports.convertStringToJson = exports.constructQueryString = exports.downloadFile = exports.replaceVariablesInString = exports.numberFormatter = exports.getErrorObject = exports.isBrowser = exports.changeToCode = void 0;
const client_1 = require("@impler/client");
const changeToCode = (str = '') => {
    var _a, _b;
    return (_b = (_a = str === null || str === void 0 ? void 0 : str.replace(/[^\s\w]/gi, '')) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === null || _b === void 0 ? void 0 : _b.replace(/ /g, '_');
};
exports.changeToCode = changeToCode;
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
function getErrorObject(error) {
    if (!error)
        return {};
    const errorStrs = error.split(`, `);
    let fieldName;
    return errorStrs.reduce((acc, val) => {
        [, fieldName] = val.split(/`/);
        acc[fieldName] = val;
        return acc;
    }, {});
}
exports.getErrorObject = getErrorObject;
const defaultDigits = 2;
function numberFormatter(num, digits = defaultDigits) {
    const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: 'k' },
        { value: 1e6, symbol: 'M' },
        { value: 1e9, symbol: 'G' },
        { value: 1e12, symbol: 'T' },
        { value: 1e15, symbol: 'P' },
        { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
        .slice()
        .reverse()
        .find(function (lookupItem) {
        return num >= lookupItem.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
}
exports.numberFormatter = numberFormatter;
function replaceVariablesInString(str, obj) {
    return str.replace(/{([^{}]*)}/g, function (a, b) {
        const value = obj[b];
        return typeof value === 'string' || typeof value === 'number' ? value : a;
    });
}
exports.replaceVariablesInString = replaceVariablesInString;
function downloadFile(blob, name) {
    var _a;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
}
exports.downloadFile = downloadFile;
function constructQueryString(obj) {
    const arr = [];
    Object.keys(obj).forEach((key) => {
        if (obj[key] !== undefined && obj[key] !== null)
            arr.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    });
    const query = arr.join('&');
    return query ? `?${query}` : '';
}
exports.constructQueryString = constructQueryString;
const convertStringToJson = (value) => {
    if ((0, client_1.isObject)(value))
        return value;
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return undefined;
    }
};
exports.convertStringToJson = convertStringToJson;
function handleApiError({ axiosInstance, error, context, shouldLog, }) {
    var _a, _b, _c, _d, _e, _f;
    const isAxios = axiosInstance.isAxiosError(error);
    const errorDetails = isAxios
        ? {
            message: error.message,
            response: (_a = error.response) === null || _a === void 0 ? void 0 : _a.data,
            status: (_b = error.response) === null || _b === void 0 ? void 0 : _b.status,
            statusText: (_c = error.response) === null || _c === void 0 ? void 0 : _c.statusText,
            headers: (_d = error.response) === null || _d === void 0 ? void 0 : _d.headers,
            url: (_e = error.config) === null || _e === void 0 ? void 0 : _e.url,
            method: (_f = error.config) === null || _f === void 0 ? void 0 : _f.method,
            context,
        }
        : {
            message: error instanceof Error ? error.message : 'Unknown error',
            stack: error instanceof Error ? error.stack : undefined,
            context,
        };
    if (shouldLog) {
        console.error(`API Error${context ? ` [${context}]` : ''}:`, errorDetails);
    }
    if (errorDetails.response && typeof errorDetails.response === 'object') {
        const response = errorDetails.response;
        if (response.message) {
            return response.message;
        }
        if (response.error && typeof response.error === 'string') {
            return response.error;
        }
        if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
            return response.errors[0].message || response.errors[0];
        }
    }
    if (errorDetails.status) {
        switch (errorDetails.status) {
            case 400:
                return 'Bad request. Please check your input data.';
            case 401:
                return 'Authentication failed. Please check your credentials.';
            case 403:
                return 'Access denied. You do not have permission to perform this action.';
            case 404:
                return 'Resource not found.';
            case 429:
                return 'Too many requests. Please try again later.';
            case 500:
                return 'Internal server error. Please try again later.';
            default:
                return errorDetails.message || 'An unexpected error occurred.';
        }
    }
    return errorDetails.message || 'An unexpected error occurred.';
}
exports.handleApiError = handleApiError;
